import { Editor, Range } from 'slate';
import isNodeTextEqualToWindowSelection from 'components/text-editor/hooks/use-custom-editor/actions/is-node-text-equal-to-window-selection';
import { ReactEditor } from 'slate-react';

export type IsTextSnippetSelected = (selection?: Range) => boolean;

export default function isTextSnippetSelected(
  editor: ReactEditor,
): IsTextSnippetSelected {
  return function (selection?: Range): boolean {
    const at = (selection ?? editor.selection) as Range;

    if (at) {
      const result = Array.from(
        Editor.nodes(editor, {
          at,
          // @ts-ignore
          match: (node) => Boolean(node.annotationId),
        }),
      );

      const textSnippets = result?.map(([node]) => node);

      if (textSnippets.length === 1) {
        const [snippet] = textSnippets;

        return isNodeTextEqualToWindowSelection(editor)(snippet);
      }
    }
    return false;
  };
}
